import React, { useState, useEffect } from "react";
import "../styles/Hero.css";
import heroImage from "../assets/images/Frame 57.png";

const phrases = [
  "Digital Innovation.",
  "Smarter Solutions.",
  "Seamless Connectivity.",
  "Accessible Technology.",
  "Effortless Experiences.",
  "A Better Tomorrow.",
];

const TypeWriter = () => {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [displayed, setDisplayed]     = useState("");
  const [typing, setTyping]           = useState(true);
  const [charIndex, setCharIndex]     = useState(0);

  useEffect(() => {
    const current = phrases[phraseIndex];

    if (typing) {
      if (charIndex < current.length) {
        const t = setTimeout(() => {
          setDisplayed(current.slice(0, charIndex + 1));
          setCharIndex(c => c + 1);
        }, 70);
        return () => clearTimeout(t);
      } else {
        // Finished typing — pause then start deleting
        const t = setTimeout(() => setTyping(false), 1800);
        return () => clearTimeout(t);
      }
    } else {
      if (charIndex > 0) {
        const t = setTimeout(() => {
          setDisplayed(current.slice(0, charIndex - 1));
          setCharIndex(c => c - 1);
        }, 40);
        return () => clearTimeout(t);
      } else {
        // Finished deleting — move to next phrase
        setPhraseIndex(i => (i + 1) % phrases.length);
        setTyping(true);
      }
    }
  }, [charIndex, typing, phraseIndex]);

  return (
    <span className="hero__typewriter">
      {displayed}
      <span className="hero__cursor">|</span>
    </span>
  );
};

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero__container">
        <div className="hero__content reveal-left">
          <h1 className="hero__title">
            Transforming Everyday Experiences Through{" "}
            <TypeWriter />
          </h1>
          <p className="hero__subtitle">
            Building innovative digital solutions that work with or without internet connectivity.
          </p>
          <div className="hero__actions">
            <a href="/solutions" className="btn btn--primary">Explore Solutions</a>
            <a href="#contact" className="btn btn--outline">Contact Us</a>
          </div>
        </div>
        <div className="hero__image-wrap reveal-right">
          <img src={heroImage} alt="Iyconsoft digital solutions network" className="hero__image" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
